"use strict";
/**
 * @file: 新版封装
 * @author: yangqianjun
 * @Date: 2019-12-17 20:16:34
 * @LastEditors: yangqianjun
 * @LastEditTime: 2020-01-06 19:58:11
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/camelcase */
var sagaEffects = tslib_1.__importStar(require("redux-saga/effects"));
exports.USER_TYPE = 'userModel/doUser';
/** 不再支持 npm 模块，必须先引入 umd */
function init(logConfig, base, type) {
    if (type === void 0) { type = exports.USER_TYPE; }
    return {
        // @IMP: 兼容高低版本typescript
        loggerSaga: function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sagaEffects.takeEvery(type, function (action) {
                            var userInfo;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!action.payload) return [3 /*break*/, 2];
                                        userInfo = action.payload.userInfo;
                                        if (!(typeof EFWebLogger !== 'undefined' && EFWebLogger.getUserId)) return [3 /*break*/, 2];
                                        if (!(typeof userInfo.userId === 'string')) return [3 /*break*/, 2];
                                        return [4 /*yield*/, EFWebLogger.setUserId(userInfo.userId)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }
    };
}
exports.default = init;
//# sourceMappingURL=logger.js.map